import React, { useEffect, useState } from "react"
import clsx from "classnames"
import PropTypes from "prop-types"
import i18n from "lib/i18n"
import { Dropdown } from "../common/Dropdown"
import watchWindowWidth from "lib/watchWindowWidth"

import { ConfigProps } from "components/PropTypes/ConfigProps"
import HeroImage from "./HeroImage"

// Shared text styles for hero title and subtitle (both white Montserrat
// above the gradient overlay). Formerly :local .title/.donatingTo in styles.scss.
const baseTextClasses = "relative z-10 text-white font-sans-heading leading-tight"

const HeroComponent = ({ config = {}, regions = [] }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useEffect(() => watchWindowWidth(setWindowWidth), [])

  const isDesktop = windowWidth > 600

  const onRegionSelect = (event) => {
    window.location = `/${event.target.value}`
  }

  // The hero text container: desktop is a centred 972px column with generous padding;
  // mobile is full-width with 32px×24px padding.
  const containerClasses = clsx(
    "relative mx-auto box-border",
    isDesktop ? "max-w-243 pt-16 pb-14" : "h-full px-6 py-8",
  )

  // Hero title: 52px on desktop, 34px on mobile.
  const titleClasses = clsx(
    baseTextClasses,
    "mb-4 font-bold whitespace-pre-line",
    isDesktop ? "text-6xl" : "text-4xl",
  )

  const regionOptions = regions.map((region) => (
    <option key={region.code} value={region.code}>
      {region.name}
    </option>
  ))

  return (
    <div className="relative after:absolute after:inset-0 after:z-1 after:bg-gradient-to-b after:from-black/20 after:to-black/50 after:content-['']">
      <HeroImage />
      <div className={containerClasses}>
        <h1 className={titleClasses}>{i18n.t("hero_component.label.title")}</h1>
        <h2 className={clsx(baseTextClasses, "mb-3 text-xl font-medium")}>
          {i18n.t("hero_component.label.you_are_donating_to")}
        </h2>
        <div className="relative z-3 w-fit">
          <Dropdown
            value={config.region_code}
            onChange={onRegionSelect}
            name="regionSelector"
            className="focus:ring-2 focus:ring-blue-600 focus:outline-hidden"
            label={i18n.t("hero_component.label.region_selector")}
          >
            {regionOptions}
          </Dropdown>
        </div>
      </div>
    </div>
  )
}

HeroComponent.propTypes = {
  config: ConfigProps,
  regions: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
}

export default HeroComponent
